import Validate from 'validator';
import error from '../../config/errorMessages';

const validatePercents = (totalGooglePercent, totalPercent, percent) => {
	let message = '';

	if (totalPercent < 100) {
		message += 'Valor não pode ser menor que 100%. \n';
	}

	if (totalPercent > 100) {
		message += 'Valor não pode utrapassar 100%. \n';
	}

	if (totalGooglePercent === 0) {
		message += 'Você deve ter pelo menos 1 canal do Google. \n';
	}

	if (!(totalGooglePercent >= percent)) {
		message += `Voçê precisa de pelo menos ${percent}% de investimento em canais do Google \n`;
	}

	return message;
};

const link = (value, required = true) => {
	let message = '';
	let valid = true;

	if (typeof value === 'undefined' && required) {
		message = error.REQUIRED_FIELD;
		valid = false;
		return { message, valid };
	}

	if (value === '' && required) {
		message = error.REQUIRED_FIELD;
		valid = false;
		return { message, valid };
	}

	if (!Validate.isEmpty(value) && !Validate.isURL(value)) {
		message = error.URL_INVALID;
		valid = false;
		return { message, valid };
	}

	return { message, valid };
};

export const validateChannels = (valueField, percent = 0.3) => {
	if (!valueField.isValidPlan) {
		return valueField;
	}

	const channels = ['facebook', 'instagram', 'googleSearch', 'googleDisplay'];
	const googleChannels = ['googleSearch', 'googleDisplay'];

	let totalPercent = 0;
	let totalGooglePercent = 0;

	for (const channel in valueField) {
		if (channel) {
			if (channels.indexOf(channel) !== -1) {
				const chanelPercent = parseFloat(valueField[channel].percent);
				totalPercent += chanelPercent;
				if (googleChannels.indexOf(channel) !== -1) {
					totalGooglePercent += chanelPercent;
				}
			}
		}
	}
	valueField.message = validatePercents(totalGooglePercent, totalPercent, percent);
	valueField.isValidPlan = Validate.isEmpty(valueField.message);

	return valueField;
};

export const validateLinks = (valueField) => {
	if (!valueField.isValidPlan) {
		return valueField;
	}

	const { facebook, instagram } = valueField;

	valueField.facebook.message = '';
	valueField.instagram.message = '';
	valueField.isValidPlan = true;

	const facebookHasPercent = parseInt(facebook.percent, 10) > 0;
	const instagramHasPercent = parseInt(instagram.percent, 10) > 0;

	if (facebookHasPercent || instagramHasPercent) {
		const { message, valid } = link(facebook.link);
		valueField.isValidPlan = valid;
		valueField.facebook.message = message;
	}

	if (instagramHasPercent) {
		const { message, valid } = link(instagram.link);
		valueField.isValidPlan = valueField.isValidPlan && valid;
		valueField.instagram.message = message;
	}

	return valueField;
};

const plan = {
	validateChannels,
	validateLinks,
};

export default plan;
